import React from 'react';
import { Text, TextLink, Spacing, Row, Column, Grid } from '@dls/web';
import { openInNewTab } from '../../helpers/common';
import AppFlexBox from '../../styles/app-flex';
import WhatsAppLogo from '@dls/assets/dist/images/web/logo_whatsapp_square.svg';
import useTranslate from '../../hooks/useTranslation';
import LINKS from '../../config/links';
import styled from 'styled-components';

const StyledWhatsAppIcon = styled(WhatsAppLogo)`
  width: 50px;
  height: 46px;
`;

export const NeedHelpSection = () => {
  const { t } = useTranslate();

  const handleWhatsAppClick = () => {
    openInNewTab(LINKS.btlWhatsAppContactLink);
  };

  return (
    <Spacing top={2} bottom={4} left={0} right={0}>
      <Grid>
        <Row noGutter>
          <Column noGutter>
            <Text type="header" tag="h4">
              {t('NEED_HELP')}
            </Text>

            <Spacing top={1}>
              <AppFlexBox gap="8px" alignItems="center">
                <StyledWhatsAppIcon
                  data-testid={`whatsapp-icon`}
                  onClick={handleWhatsAppClick}
                ></StyledWhatsAppIcon>
                <TextLink onClick={handleWhatsAppClick}>
                  {t('CHAT_WITH_US')}
                </TextLink>
              </AppFlexBox>
            </Spacing>
          </Column>
        </Row>
      </Grid>
    </Spacing>
  );
};

export default NeedHelpSection;
